module.exports = __webpack_public_path__ + "static/media/tortilla.1320479c.jpg";